import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useI18n } from '@/contexts/I18nContext';

const statusConfig = {
  draft: { key: 'status.draft', className: 'bg-gray-100 text-gray-800 border-gray-200' },
  submitted: { key: 'status.submitted', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  under_review: { key: 'status.under_review', className: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  approved: { key: 'status.approved', className: 'bg-green-100 text-green-800 border-green-200' },
  rejected: { key: 'status.rejected', className: 'bg-red-100 text-red-800 border-red-200' },
  correction_needed: { key: 'status.correction_needed', className: 'bg-orange-100 text-orange-800 border-orange-200' },
};

export function StatusBadge({ status }) {
  const { t } = useI18n();
  const config = statusConfig[status] || statusConfig.draft;
  return (
    <Badge variant="outline" className={`${config.className} border font-medium`} data-testid={`status-badge-${status}`}>
      {t(config.key)}
    </Badge>
  );
}
